import { Injectable } from '@angular/core';
import { DataUrl } from '../../../utils/utils';
import * as mobilenet from '@tensorflow-models/mobilenet';
import '@tensorflow/tfjs-backend-webgl';
@Injectable({
  providedIn: 'root'
})


export class TensorflowClassifyImageService   {

  private model: mobilenet.MobileNet | undefined = undefined;

  constructor() {
    }

  async classifyImage(imgBase64: DataUrl) : Promise<{className: string, probability: number}[]>{
    return new Promise<{className: string, probability: number}[]>(async (resolve) => {
      if(!this.model){
        await this.initModel();
      }
      if(this.model){
        const imgEl = new Image();
        imgEl.src = imgBase64.toString();
        imgEl.onload = async () => {
          try {
            const classification = await this.model.classify(imgEl);
            resolve(classification);
          } catch (error) {
            console.log("Image classification failed",error);
            resolve([]);
          }
        }
      }else{
        console.log("Model not initalized");
        resolve([]);
      }
    })

  }

  async initModel(){
    console.log("Starting mobilenet model init")
    this.model = await mobilenet.load({version: 2, alpha: 1.0});
    console.log("Finished mobilenet model init")
  }
}
